import "../styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import React from "react";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { faCalendarLines } from "@fortawesome/pro-duotone-svg-icons";
import LoadingApp from "../../../../components/LoadingApp";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { Convite } from "../../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";
import { InvitationCardProps } from "../../../../interfaces/props/SaudeBemEstar/PalestrasEventos/InvitationCardProps";
import {
  getInvitation,
  postConfirmAttendance,
} from "../../../../services/SaudeBemEstar/PalestrasEventosService";
import { capitalize } from "../../../../utils/Capitalize";
import { sxButton, sxDivider, sxTextButton } from "../sxProps";
import ModalActionV1 from "../../../../components/ModalActionResponsive";

const getStatusColor = (convite: Convite) => {
  if (convite.evento.descrStatus === "NÃO VOU") return "error";
  else return "";
};

const getStatusDescricao = (convite: Convite) => {
  if (convite.evento.descrStatus === "NÃO VOU") return convite.evento?.descrStatus;
  else return "-";
};

const getStatusSufix = (convite: Convite) => {
  if (convite.evento.descrStatus === "NÃO VOU" && convite.evento.dtCancelamento)
    return " - " + convite.evento.dtCancelamento;
  else return "";
};

export const InvitationCard: React.FC<InvitationCardProps> = (props) => {
  const [confirmAttendanceModalOpen, setConfirmAttendanceModalOpen] =
    React.useState(false);
  const [confirmAttendanceErrorMessage, setConfirmAttendanceErrorMessage] =
    React.useState("");
  const [invitation, setInvitation] = React.useState<Convite | null>(null);
  const [confirmAttendanceLoading, setConfirmAttendanceLoading] =
    React.useState(false);

  const accessibility = useAccessibility();

  const evento = invitation || props.convite;

  const closeConfirmAttendanceModal = () =>
    setConfirmAttendanceModalOpen(false);
  const openConfirmAttendanceModal = () => setConfirmAttendanceModalOpen(true);
  const closeErrorModal = () => {
    setConfirmAttendanceErrorMessage("");
    props.reloadPage();
  };
  const confirmAttendance = () => {
    setConfirmAttendanceModalOpen(false);
    setConfirmAttendanceLoading(true);
    const body = {
      idCtrlEventoUsr: evento.evento.idCtrlEventoUsr,
      idCtrlProgEvento: evento.evento.idCtrlProgEvento,
    };
    postConfirmAttendance(body)
      .catch((error) =>
        setConfirmAttendanceErrorMessage(error?.mensagem || " ")
      )
      .finally(() => {
        setConfirmAttendanceLoading(false);
        props.reloadPage();
      });
  };

  React.useEffect(() => {
    getConvite();
  }, []);

  const getConvite = () => {
    setInvitation(null);
    getInvitation({
      idCtrlEventoUsr: evento.evento.idCtrlEventoUsr,
      idCtrlProgEvento: evento.evento.idCtrlProgEvento,
    }).then(setInvitation);
  };

  const nomePrestador =
    invitation?.nomePrestador && capitalize(invitation?.nomePrestador);
  const especialidade =
    invitation?.especialidade && capitalize(invitation?.especialidade);
  const dataHora = [evento.evento.data, evento.evento.hora]
    .filter(Boolean)
    .join(" ");
  const addressValue = evento?.evento.complementos?.find(
    (c) => c.codigo === "ENDER"
  )?.valor;
  const address =
    evento?.evento.tipoEvento === "P" && addressValue
      ? capitalize(addressValue)
      : addressValue;

  return (
    <div>
      <div
        className="invitation-card-holder"
        tabIndex={-1}
        style={{
          ...accessibility.contrastStyle,
          ...accessibility.contrastBorderAccessibility,
        }}
      >
        <div className="palestra-card-icon-holder">
          <FontAwesomeIcon
            style={accessibility.contrastColorAccessibility}
            icon={faCalendarLines}
            className="fadt-file-contract"
          />
        </div>
        <div className="invitation-card-content">
          <Typography style={accessibility.textStyleAccessibility}>
            <b>Palestra:</b> {evento.evento?.titulo}
          </Typography>
          <Typography style={accessibility.textStyleAccessibility}>
            <b>Convite enviado por:</b> {nomePrestador}
          </Typography>
          <Typography style={accessibility.textStyleAccessibility}>
            <b>Especialidade:</b> {especialidade}
          </Typography>
          <Typography className="invitation-card-description" style={accessibility.textStyleAccessibility}>
            <b >Descrição:</b>
            <div
              style={accessibility.textStyleAccessibility}
              className="invitation-card-description"
              dangerouslySetInnerHTML={{ __html: invitation?.evento?.descr ?? '-' }}
            />
          </Typography>
          <Divider sx={sxDivider} />
          <Typography style={accessibility.textStyleAccessibility}>
            <b>Data e hora do evento:</b> {dataHora}
          </Typography>
          <Typography style={accessibility.textStyleAccessibility}>
            <b>Modalidade:</b> {evento.evento.descrTipoEvento}
          </Typography>
          {evento?.evento.tipoEvento === "P" && (
            <Typography style={accessibility.textStyleAccessibility}>
              <b>Endereço:</b> {address}
            </Typography>
          )}
          <div className="invitation-card-content-row">
            <Typography style={accessibility.textStyleAccessibility}>
              <b>Situação:&nbsp;</b>
            </Typography>
            <Typography
              style={accessibility.textStyleAccessibility}
              color={getStatusColor(props.convite)}
            >
              <b>{getStatusDescricao(props.convite)}&nbsp;</b>
            </Typography>
            <Typography style={accessibility.textStyleAccessibility}>
              {getStatusSufix(props.convite)}
            </Typography>
          </div>
          <div className="invitation-card-actions">
            <Button
              className="invitation-card-action-button"
              variant="contained"
              style={accessibility.buttonStyleAccessibility}
              sx={sxButton}
              onClick={openConfirmAttendanceModal}
              aria-label={`Ingressar em ${evento.evento?.titulo}, agendado para ${evento.evento.data} as ${evento.evento.hora}, sobre ${evento.evento.descr}, que será ${evento.evento.tipoEvento}`}
            >
              <Typography
                style={accessibility.buttonTextStyleAccessibility}
                sx={sxTextButton}
              >
                CONFIRMAR PRESENÇA
              </Typography>
            </Button>
          </div>
        </div>
      </div>
      <LoadingApp showLoading={confirmAttendanceLoading} />
      <ModalActionV1
        showModal={confirmAttendanceModalOpen}
        handleShowModal={closeConfirmAttendanceModal}
        textOutlinedButton="NÃO"
        textContainedButton="SIM"
        colorContainedButton="success"
        title="Atenção"
        subTitle="Quer confirmar a presença no evento?"
        handleOutlinedButton={closeConfirmAttendanceModal}
        handleContainedButton={confirmAttendance}
        icon="warning"
        width="578px"
      />
      <ModalFeedBack
        showButtonModal
        showModal={!!confirmAttendanceErrorMessage}
        handleButtonModal={closeErrorModal}
        handleShowModal={closeErrorModal}
        textButton="FECHAR"
        title="Erro ao confirmar presença"
        subTitle={confirmAttendanceErrorMessage}
        icon="error"
        classNameModal="modal-feedback-invitation"
      />
    </div>
  );
};
